import { render, staticRenderFns } from "./management-consulting.vue?vue&type=template&id=f1c89080&scoped=true"
var script = {}
import style0 from "./management-consulting.vue?vue&type=style&index=0&id=f1c89080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c89080",
  null
  
)

export default component.exports